module.exports = __webpack_public_path__ + "static/media/ma4.5c65942f.png";